import PropTypes from 'prop-types';
import { FormattedMessage } from 'dibs-react-intl';
import { PANES } from '../../constants/checkoutConstants';
import styles from './styles/checkoutPaneTitle.scss';
import NumberedPaneTitle from './NumberedPaneTitle';

export const titles = {
    [PANES.PANE_SIDEMARK]: (
        <FormattedMessage id="checkout.CheckoutPaneTitle.sidemark" defaultMessage="Notes" />
    ),
    [PANES.PANE_PROJECT]: (
        <FormattedMessage id="checkout.CheckoutPaneTitle.project" defaultMessage="Project" />
    ),
    [PANES.PANE_SHIPPING]: (
        <FormattedMessage
            id="checkout.CheckoutPaneTitle.shipping"
            defaultMessage="Shipping Address"
        />
    ),
    [PANES.PANE_DELIVERY]: (
        <FormattedMessage
            id="checkout.CheckoutPaneTitle.delivery"
            defaultMessage="Shipping Method"
        />
    ),
    [PANES.PANE_PAYMENT]: (
        <FormattedMessage id="checkout.CheckoutPaneTitle.payment" defaultMessage="Payment Method" />
    ),
    [PANES.PANE_REVIEW]: (
        <FormattedMessage
            id="checkout.CheckoutPaneTitle.review"
            defaultMessage="Review Your Order"
        />
    ),
};

const CheckoutPaneTitle = ({ wrapperClasses, pane }) => (
    <div className={wrapperClasses}>
        <h3 className={styles.title}>
            <NumberedPaneTitle {...{ pane, title: titles[pane] }} />
        </h3>
        <span className={styles.bar} />
    </div>
);

CheckoutPaneTitle.propTypes = {
    wrapperClasses: PropTypes.string,
    pane: PropTypes.oneOf(Object.values(PANES)).isRequired,
};

CheckoutPaneTitle.defaultTypes = {
    wrapperClasses: '',
};

export default CheckoutPaneTitle;
